"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BetValidator = (function () {
    function BetValidator() {
    }
    BetValidator.error = function (error) {
        this.element.classList.remove('fade');
        this.element.style.display = 'flex';
        document.getElementById('modalErrorMessage').innerHTML = error;
    };
    BetValidator.element = document.getElementById('buyTicketError');
    return BetValidator;
}());
exports.default = BetValidator;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/validators/bet-validator.ts
// module id = 189
// module chunks = 5